import { render, staticRenderFns } from "./DestruccionRegistra.vue?vue&type=template&id=ea17e334&"
import script from "./DestruccionRegistra.vue?vue&type=script&lang=js&"
export * from "./DestruccionRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports